import {HttpClient} from "@angular/common/http";
import {BehaviorSubject, Observable, map, tap} from "rxjs";
import {Injectable} from "@angular/core";
import {ActionResult, ActionResultList, Message} from "@model";
import {EnvironmentService} from "./environment.service";

@Injectable({ providedIn:'root' })
export class MessageService {
  private static _unreadMessages: BehaviorSubject<Message[] | undefined> = new BehaviorSubject<Message[] | undefined>(undefined);
  private static _readMessages: BehaviorSubject<Message[] | undefined> = new BehaviorSubject<Message[] | undefined>(undefined);

  static get unreadMessages(): BehaviorSubject<Message[] | undefined> {
    return this._unreadMessages;
  }

  static get readMessages(): BehaviorSubject<Message[] | undefined> {
    return this._readMessages;
  }

  constructor(private http: HttpClient, private environmentService:EnvironmentService) {
  }

  getUserMessages(read: boolean, onStartFetch?: () => void, onEndFetch?: () => void): Observable<Message[]> {
    if (onStartFetch) {
      onStartFetch();
    }
    return this.http.post<ActionResultList<(Message)[], number>>(this.environmentService.getApiUrl() + "/api/messages/user", read).pipe(tap(() => {
        if (onEndFetch) {
          onEndFetch();
        }
      }), map((value: ActionResultList<Message[], number>) => {
        if (value && value.result && value.result.length != 0) {
          return value.result;
        } else {
          return [];
        }
      })
    );
  }


  getMessageById(messageId: number | undefined): Observable<Message | undefined> {
    return this.http.post<ActionResult<Message>>(this.environmentService.getApiUrl() + "/api/messages/byid", messageId).pipe(
      map((value: ActionResult<Message>) => {
        return value.result ?? undefined;
      }));
  }

  deleteMessage(messageId: number, onSuccess: () => void, onError: () => void) {
    this.http.post<ActionResult<boolean>>
    (this.environmentService.getApiUrl() + "/api/messages/delete", messageId).subscribe((actionResult: ActionResult<boolean>) => {
      if (actionResult.resultCode !== -1) {
        onSuccess();
      } else {
        onError();
      }
    });
  }

  addMessage(message: Message, onSuccess: () => void, onError: () => void) {
    this.http.post<ActionResult<boolean>>(this.environmentService.getApiUrl() + "/api/messages/add", message).subscribe((actionResult: ActionResult<boolean>) => {
      if (actionResult.resultCode !== -1) {
        onSuccess();
      } else {
        onError();
      }
    });
  }
}
